/** Browsers may leave the MIME type empty for files dragged from the desktop. */
export function isPdfFile(file: Pick<File, "name" | "type">) {
  return file.type === "application/pdf" || /\.pdf$/i.test(file.name);
}

export function isDxfFile(file: Pick<File, "name" | "type">) {
  return (
    /\.dxf$/i.test(file.name) ||
    ["application/dxf", "application/x-dxf", "image/vnd.dxf"].includes(
      file.type,
    )
  );
}

import { IMAGE_TYPES } from "./images";

const imageMime: Record<string, string> = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  webp: "image/webp",
};
export function inferredFileType(file: Pick<File, "type" | "name">) {
  if (file.type && file.type !== "application/octet-stream") return file.type;
  if (isPdfFile(file)) return "application/pdf";
  return (
    imageMime[file.name.split(".").pop()?.toLowerCase() || ""] || file.type
  );
}
export function normalizeBoardFile(file: File) {
  const type = inferredFileType(file);
  return type === file.type
    ? file
    : new File([file], file.name, { type, lastModified: file.lastModified });
}
export function isPreviewImage(file: Pick<File, "type" | "name">) {
  return !isDxfFile(file) && IMAGE_TYPES.includes(inferredFileType(file));
}

export function downloadDisposition(name: string) {
  const safe = name.replace(/[\r\n\x00-\x1f\x7f/\\]/g, "_");
  return `attachment; filename="${safe.replace(/[^\x20-\x7e]|["\\]/g, "_")}"; filename*=UTF-8''${encodeURIComponent(safe).replace(/['()*]/g, (c) => "%" + c.charCodeAt(0).toString(16).toUpperCase())}`;
}

/** Keep document files out of the image decoder and retain the PDF page choice. */
export function routeBoardFiles(
  files: File[],
  handlers: {
    images: (files: File[]) => void;
    documents: (files: File[]) => void;
  },
) {
  files = files.map(normalizeBoardFile);
  if (files.some((file) => isPdfFile(file) || !isPreviewImage(file)))
    handlers.documents(files);
  else if (files.length) handlers.images(files);
}
